interface ElementsLegendProps {
  language: "ka" | "en";
}

export const ElementsLegend = ({ language }: ElementsLegendProps) => {
  const content = {
    ka: {
      elements: [
        {
          icon: "/models/treasure-hunt/bottle-sea.jpg",
          title: "შეტყობინება",
          description: "წაიკითხეთ და დატოვეთ შეტყობინებები სხვა მოთამაშეებისთვის",
        },
        {
          icon: "/models/treasure-hunt/man-sand.png",
          title: "გაცნობა",
          description: "იპოვეთ წყვილი გაცნობების საშუალებით",
        },
        {
          icon: "/models/treasure-hunt/chest-sea.jpg",
          title: "პრიზი",
          description: "გახსენით სუნდუქები და მიიღეთ პრიზები",
        },
      ],
    },
    en: {
      elements: [
        {
          icon: "/models/treasure-hunt/bottle-sea.jpg",
          title: "Message",
          description: "Read and leave messages to other players",
        },
        {
          icon: "/models/treasure-hunt/man-sand.png",
          title: "Acquaintance",
          description: "Find a match through acquaintances",
        },
        {
          icon: "/models/treasure-hunt/chest-sea.jpg",
          title: "Prize",
          description: "Open chests and get prizes",
        },
      ],
    },
  };

  const text = content[language] || content.ka;

  return (
    <div
      className="absolute left-4 top-1/2 -translate-y-1/2 z-20 max-w-xs"
      style={{
        fontFamily: "MinecraftGeorgian, monospace",
      }}
    >
      <div style={{ backgroundColor: "#EDD4AE" }}>
        <div
          className="relative overflow-hidden"
          style={{
            backgroundImage: "url(/models/treasure-hunt/ui/modal.png)",
            backgroundSize: "100% 100%",
            scale: "1.1",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            imageRendering: "pixelated",
            padding: "20px",
          }}
        >
          {/* Горизонтальный список элементов */}
          <div className="flex flex-col px-6 py-4 relative z-10">
            {/* Иконки */}
            <div className="flex items-center gap-3 mb-2">
              {text.elements.map((element, index) => (
                <div key={index} className="flex flex-col items-center gap-1">
                  {/* Иконка в рамке */}
                  <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center relative flex-shrink-0">
                    <img
                      src={element.icon}
                      alt=""
                      className="max-w-full max-h-full object-contain relative z-0"
                      style={{ imageRendering: "pixelated" }}
                    />
                    <div
                      className="absolute text-center pointer-events-none z-10"
                      style={{
                        top: "-4px",
                        left: "-4px",
                        right: "-4px",
                        bottom: "-4px",
                        backgroundImage:
                          "url(/models/treasure-hunt/ui/square-frame.png)",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        imageRendering: "pixelated",
                      }}
                    />
                  </div>
                  {/* Заголовок */}
                  <p className="text-amber-900 text-[10px] font-bold text-center leading-tight whitespace-nowrap">
                    {element.title}
                  </p>
                </div>
              ))}
            </div>

            {/* Описания */}
            <div className="border-t-2 border-amber-800/30 pt-2 space-y-0.5">
              {text.elements.map((element, index) => (
                <p
                  key={index}
                  className="text-amber-900 text-[10px] leading-tight"
                >
                  <span className="font-bold">{element.title}:</span>{" "}
                  {element.description}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
